import { Input, Table, extendTheme } from "@chakra-ui/react";
import buttonTheme from "./components/button";
import containerTheme from './components/container';
import checkboxTheme from "./components/checkbox";
import textareaTheme from "./components/textarea";
import selectTheme from "./components/select";
import tableTheme from "./components/table";
import inputTheme from "./components/input";
import linkTheme from "./components/link";

const theme = extendTheme({
    initialColorMode: "light",
    useSystemColorMode: false,
    breakpoints: {
        // mobile: "0px",
        // tablet: "1280px",
        // laptop: "1281px",
        // desktop: "1440px",
        sm: "320px",  // Small screens / smartphones
        md: "768px",  // Medium screens / tablets
        lg: "1024px", // Large screens / laptops
        xl: "1280px", // Extra large screens / desktops
    },
    fonts: {
        heading: "Helvetica Neue, Helvetica, Arial, sans-serif",
        body: "Helvetica Neue, Helvetica, Arial, sans-serif",
        mono: "Helvetica Neue, Helvetica, Arial, sans-serif",
        text: "Helvetica Neue, Helvetica, Arial, sans-serif",
    },
    colors: {
        primary: {
            runningText: "#333333",
            bgHeading: "#91CACA",
            bgGrey: "#f5f5f5",
            borderGrey: "#e3e3e3",
            error: "red",
        },
    },
    styles: {
        global: {
            body: {
                position: "relative",
                zIndex: 1,
            },
        },
    },
    components: {
        Heading: {
            baseStyle: {
                color: "primary.runningText",
            },
            variants: {
                h1: {
                    fontSize: "36px",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "1.1",
                    p: "10px 0",
                    textAlign: "center",
                    bgColor: "primary.bgHeading",
                },
                h2: {
                    fontSize: "30px",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "1.1",
                    mt: "20px",
                    mb: "10px",
                },
                h3: {
                    fontSize: ["16px", "20px"], // Mobile: 16px, Desktop: 22px
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "normal",
                },
            },
            defaultProps: {
                size: "",
                fontSize: "",
                lineHeight: "",
                variant: "",
                colorScheme: "",
                margin: 0,
                padding: 0,
            },
        },
        Text: {
            baseStyle: {
                color: "primary.runningText",
            },
            variants: {
                runningText: {
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                },
                runningTextSb: {
                    fontSize: ["16px", "20px"], // Mobile: 16px, Desktop: 22px
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "normal",
                },
                runningTextSmall: {
                    fontSize: ["14px", "18px"], // Mobile: 14px, Desktop: 18px
                    fontStyle: "normal",
                    fontWeight: "normal",
                    lineHeight: "normal",
                },
            },
        },
        FormLabel: {
            baseStyle: {
                color: "primary.runningText",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "20px",
                mb: "5px",
            },
        },
        Link: {
            baseStyle: {
                color: "white",
                fontSize: ["16px", "20px"], // Mobile: 16px, Desktop: 22px
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "normal",
            },
        },
        Button: buttonTheme,
        Container: containerTheme,
        Checkbox: checkboxTheme,
        Textarea: textareaTheme,
        Select: selectTheme,
        Input: inputTheme,
        Table: tableTheme,
        Link: linkTheme,
    },
});

export default theme;
